import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';
import { getUserRole } from '../utils/roleAccess';

const RouteGuard = ({ canView, children }) => {
  if (!canView) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
};

export const RoleRouteGuard = ({ check, children }) => {
  const { user } = useUser();
  const role = getUserRole(user);
  const canView = typeof check === 'function' ? check(role) : !!check;
  return <RouteGuard canView={canView}>{children}</RouteGuard>;
};

export default RouteGuard;
